import { useQueryClient } from "@tanstack/react-query";
import { trpc } from "../trpc";
import { getQueryKey } from "@trpc/react-query";

export function useBulkTestAuthentications() {
  const queryClient = useQueryClient();

  const authenticationsKey = getQueryKey(
    trpc.authentication.authentications,
    undefined,
    "any",
  );

  const mutation = trpc.authentication.bulkTest.useMutation({
    onMutate: async () => {
      await queryClient.cancelQueries({ queryKey: authenticationsKey });
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: authenticationsKey });
    },
  });

  return {
    bulkTestAuthentications: mutation.mutateAsync,
    isLoading: mutation.isPending,
  };
}
